import { faPlus, faPencil, faCar, faFileImport, faTrailer, faSailboat } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const getChartColor = (index) => {
    const colors = ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd", "#8c564b", "#e377c2", "#7f7f7f", "#bcbd22", "#17becf"];
    return colors[index % colors.length]; // Ensure it doesn't exceed the available colors
};

export const largeNumberFormatter = (number) => {
    if (number === 0) return "0";

    const formatNumber = (num) => num.toFixed(2);

    if (number > 0) {
        if (number > 1000000000) {
            return formatNumber(number / 1000000000) + 'B';
        } else if (number > 1000000) {
            return formatNumber(number / 1000000) + 'M';
        } else if (number > 1000) {
            return formatNumber(number / 1000) + 'K';
        } else {
            return number.toFixed(2);
        }
    } else {
        // negative numbers
        if (number < -1000000000) {
            return '-' + formatNumber(-number / 1000000000) + 'B';
        } else if (number < -1000000) {
            return '-' + formatNumber(-number / 1000000) + 'M';
        } else if (number < -1000) {
            return '-' + formatNumber(-number / 1000) + 'K';
        } else {
            return number.toFixed(2);
        }
    }
}

export const formatQuarterYear = (entry) => {
    return `Q${entry?.Quarter} '${entry?.Year?.toString()?.slice(-2)}`
}
export const assetClassToIcon = (assetClassId) => {
    const icon = assetClassId == 1 ? faCar : assetClassId == 2 ? faTrailer : assetClassId == 3 ? faSailboat : null;
    return <FontAwesomeIcon icon={icon} />
}

export const formatDateToMMDDYYYY = (dateString) => {
    if (!dateString) return null;

    const result = new Intl.DateTimeFormat('en-US').format(new Date(dateString));
    return result;
}
export const formatDateToMMDDYYYYWithTime = (dateString) => {
    if (!dateString) return null;

    const formatter = new Intl.DateTimeFormat('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });

    return formatter.format(new Date(dateString));
}
export const formatDateToYYYYMMDD = (dateString) => {
    if (!dateString) return null;

    const result = new Date(dateString).toISOString().split("T")[0];
    return result;
}

export const formatCurrency = (number) => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(number);
}
export const getInitials = (name) => {
    if (!name) return '';
    if (name === ' ') return '';

    const parts = name.trim().split(' ');
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};
export const tableSort = (a, b, sortColumn, sortDirection) => {
    const aVal = a[sortColumn];
    const bVal = b[sortColumn];

    // Numeric sort
    if (typeof aVal === 'number' && typeof bVal === 'number') {
        return sortDirection === 'asc' ? aVal - bVal : bVal - aVal;
    }

    //date sort
    const aDate = new Date(aVal);
    const bDate = new Date(bVal);
    const isValidDate = (d) => d instanceof Date && !isNaN(d);
    if (isValidDate(aDate) && isValidDate(bDate)) {
        return sortDirection === 'asc' ? aDate.getTime() - bDate.getTime() : bDate.getTime() - aDate.getTime();
    }


    // String sort (case insensitive)
    const aStr = aVal?.toString().toLowerCase() || '';
    const bStr = bVal?.toString().toLowerCase() || '';
    if (aStr < bStr) return sortDirection === 'asc' ? -1 : 1;
    if (aStr > bStr) return sortDirection === 'asc' ? 1 : -1;
    return 0;
}
export const bytesToBase64 = (bytes) => {
    let binary = '';
    const byteArray = new Uint8Array(bytes); // make sure it's Uint8Array
    byteArray.forEach(b => binary += String.fromCharCode(b));
    return window.btoa(binary);
}

export const downloadDocumentFromUrl = async (url, filename = "image.jpg") => {
  try {
    const response = await fetch(url, { mode: 'cors' }); // Make sure CORS is allowed
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl); // Clean up
  } catch (err) {
    console.error("Download failed:", err);
  }
};